<template>
  <d-modal
    @close="handleClose"
    size="lg">
    <d-modal-header>
      <d-modal-title>
        Add new passenger
      </d-modal-title>
    </d-modal-header>
    <d-modal-body>
      <passenger-form
        :isPopup="true"
        :customerID="customerID" />
    </d-modal-body>
  </d-modal>
</template>

<script>
import PassengerForm from './../forms/PassengerForm.vue';

export default {
  name: 'add-passenger-popup',
  props: [
    'customerID'
  ],
  components: {
    'passenger-form': PassengerForm
  },
  methods: {
    handleClose () {
      this.$bus.$emit('add-passenger-popup-close');
    },
    cancel () {
      this.handleClose();
    }
  }
}
</script>
